module.exports = __webpack_public_path__ + "static/media/sort_arrows.f3a18923.svg";